import React from "react";
import ErrorDisplay from "@directv-digital/dds.ui.error-display";
import DtvBox from "@directv-digital/dds.ui.dtv-box";
import DtvText from "@directv-digital/dds.ui.dtv-text";
import Checkbox from "@directv-digital/fusion.atoms.checkbox";
import TonalIcon from "../TonalIcon";
// Generated by Copilot- Start - 2026-04-10 19:44:56
// useOptionalComparePkgTrayContext returns undefined instead of throwing when
// rendered outside a ComparePkgTrayProvider, preventing the [DtvErrorDisplay]
// error triggered when useComparePkgTrayContext throws outside a provider.
import { useOptionalComparePkgTrayContext } from "../../../ComparePackageTray";
// Generated by Copilot- End - 2026-04-10 19:44:56
import { fireModalOpenCloseEventGA } from "@directv-digital/dds.services.analytics-service";

// Generated by Copilot- Start - 2026-04-10 20:24:44
// Typed fallback used when CardBottomSection renders outside a ComparePkgTrayProvider.
// Each no-op matches the real callback signature so TypeScript does not infer a
// zero-arg union and produce "Expected 0 arguments, but got 1" errors at call sites.
const COMPARE_PKG_TRAY_FALLBACK = {
  compareText: "",
  isComparePkgTray: false,
  selectedItems: [] as any[],
  updateSelectedTag: (_tag: any) => undefined,
  setTrayOpen: (_open: boolean) => undefined,
  trayOpen: false,
  updateCollapsedTray: (_collapsed: boolean) => undefined
};
// Generated by Copilot- End - 2026-04-10 20:24:44

const styles = {
  bottomSectionStyles: {
    p: "16px",
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    alignItems: "flex-end"
  },
  offerRibbonStyles: {
    p: "2px 4px",
    borderRadius: "2px",
    mb: "2px",
    fontSize: "12px !important",
    width: "fit-content",
    height: "fit-content"
  },
  strikeThroughPriceStyles: {
    textDecoration: "line-through",
    fontSize: "12px !important"
  },
  cardRightArrowStyles: {
    p: "4px 8px 4px 8px",
    borderRadius: "50%",
    width: "36px",
    height: "36px"
  }
};

export interface CardBottomSectionProps {
  index: number;
  offerRibbon: any;
  strikeThroughPrice: any;
  priceText: any;
  rightArrow: any;
  cardType: string;
  title?: string;
  cardQueryParam?: string;
  pkgType?: string;
  targetUrl?: string;
}

const CardBottomSection = (props: CardBottomSectionProps) => {
  const { offerRibbon, strikeThroughPrice, priceText, rightArrow, cardType, cardQueryParam, pkgType, targetUrl } = props;
  // Generated by Copilot- Start - 2026-04-10 20:24:44
  // Fall back to typed no-ops when rendered outside a ComparePkgTrayProvider
  // so the component renders normally without throwing.
  const {
    compareText,
    isComparePkgTray,
    selectedItems,
    updateSelectedTag,
    setTrayOpen,
    trayOpen,
    updateCollapsedTray
  } = useOptionalComparePkgTrayContext() ?? COMPARE_PKG_TRAY_FALLBACK;
  // Generated by Copilot- End - 2026-04-10 20:24:44
  const hoverBackground = () => {
    switch (cardType) {
      case "modal":
        return rightArrow?.hoverBackground || "#0004433D";
      case "redirect":
        return rightArrow?.hoverBackground || "#AACDF980";
      default:
        return rightArrow?.hoverBackground || "#AACDF980";
    }
  };
  const handleCompareEvent = queryparam => {
    updateSelectedTag(queryparam);
    const isCollapsed = !selectedItems.includes(queryparam);
    updateCollapsedTray(isCollapsed);
    setTrayOpen(true);
    !trayOpen && fireModalOpenCloseEventGA({
      dim_name: "open",
      dim_value: "comparison_tray"
    });
  }

  try {
    return (
      <DtvBox sx={{ ...styles.bottomSectionStyles }}>
        {/* Offer Ribbon | Strike Through Price | Price */}
        <DtvBox sx={{
 width: '100%',
display: "flex",
flexDirection: "row",
justifyContent: "space-between",
alignItems: "center"
}}>
          {strikeThroughPrice && offerRibbon?.content && (
            <DtvText
              {...offerRibbon}
              sx={{
                ...styles.offerRibbonStyles,
                background: offerRibbon?.background
              }}
            />
          )}
          {(isComparePkgTray && pkgType === 'genre') &&
            <DtvBox
              sx={{
                  marginLeft: "auto",
                  ".MuiFormControlLabel-root": {
                    alignItems: "center",
                    margin: "0px !important"
                  },
                  ".MuiCheckbox-root": {
                    width: "20px !important",
                    height: "20px !important",
                    "& svg": {
                      width: "20px !important",
                      height: "20px !important"
                    }
                  },
                  '.MuiTypography-root p': {
                    fontSize: '14px !important'
                  }
              }}
              onClick={e => {
                e.stopPropagation();
              }}
            >
              <Checkbox
                aria-checked={selectedItems.includes(cardQueryParam)}
                checked={selectedItems.includes(cardQueryParam)}
                {...{
                label: compareText?.content,
                mode: "dark",
                variant: "Checkbox Label",
                checkboxoptions: [
                  {
                  label: compareText?.content,
                  value: "compare",
                  checked: false,
                  disabled: false,
                  ariaLabel: "Compare genre pack",
                  dataLinkposition: "genre_card",
                  dataLinkdestination: "comparison_tray_modal"
                  }
                ]
                }}
                onChange={event => {
                  event?.stopPropagation();
                  handleCompareEvent(cardQueryParam);
                }}
              />
              </DtvBox>
          }
        </DtvBox>
        {/* tonal right arrow button */}

        <DtvBox
          sx={{
            width: '100%',
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between"
          }}
        >
          <DtvBox sx={{
 display: "flex",
flexDirection: "column",
minHeight: "44px",
justifyContent: "flex-end"
}}>
            {strikeThroughPrice?.content && (
              <DtvText
                color="#FFFFFFB2"
                variant="smalltext"
                {...strikeThroughPrice}
                sx={{ ...styles.strikeThroughPriceStyles }}
              />
            )}
            {priceText?.content && (
              <DtvBox>
                <DtvText {...priceText} />
                {/* spanText (no-promo suffix) and duration (promo suffix) are mutually exclusive */}
                {priceText?.duration ? (
                  <DtvText
                    {...priceText}
                    content={priceText?.duration}
                    sx={{ fontSize: "12px !important" }}
                  />
                ) : (
                  <DtvText
                    {...priceText?.spanText}
                    sx={{ fontSize: "12px !important" }}
                  />
                )}
              </DtvBox>
            )}
          </DtvBox>
          {(() => {
            const tonalIcon = (
              <TonalIcon
                alt={rightArrow?.alt}
                background={rightArrow?.background || "#AACDF929"}
                height={rightArrow?.height || "16px"}
                hoverBackground={hoverBackground()}
                icon={rightArrow?.icon}
                tabIndex={-1}
                title={props.title}
                width={rightArrow?.width || "16px"}
              />
            );
            return targetUrl && cardType !== "modal" ? (
              <a
                aria-label={props.title ? `Navigate to ${props.title} genre pack` : 'Navigate to genre pack'}
                href={targetUrl}
                role="button"
                onClick={e => e.stopPropagation()}
                onKeyDown={e => {
                  if (e.key === ' ') {
                    e.preventDefault();
                    window.location.href = targetUrl;
                  }
                }}
              >
                {tonalIcon}
              </a>
            ) : tonalIcon;
          })()}
        </DtvBox>
      </DtvBox>
    );
  } catch (error) {
    return <ErrorDisplay component="CardBottomSection" error={error} />;
  }
};

export default React.memo(CardBottomSection);
